module.exports = __webpack_public_path__ + "img/96.1.c9349824.jpg";